import { getLiveLayoutColors } from './helper/presentationLive';
import {
  SpeakerSlashIcon as VolumeOffIcon,
  SpeakerHighIcon as VolumeUpIcon
} from '@phosphor-icons/react';
import HoverBox from '@atoms/HoverBox';

const SOUND_FEATURE_TYPES = ['map', 'talkingTiles', 'newWheel', 'wheel', 'quiz'];

const Volume = ({

  layoutTheme = 'dark',
  isMuted = true,
  setIsMuted,
  currentRosFeature,
  layoutMode,
  isDisabled = false
}: {
  layoutTheme: 'dark' | 'light',
  layoutMode: 'square' | 'rectangle',
  isMuted: boolean,
  setIsMuted: (isMuted: boolean) => void,
  currentRosFeature: any,
  isDisabled?: boolean
}) => {
  const colors = getLiveLayoutColors(layoutTheme);
  const handleVolumeToggle = () => {
    setIsMuted(!isMuted);
  };

  const hasSoundFeature = () => {
    const hasSoundFeature = SOUND_FEATURE_TYPES.some(type => currentRosFeature?.type?.includes(type));
    return hasSoundFeature;
  };
  if (!hasSoundFeature()) return null;

  const isRectLayout = layoutMode === 'rectangle';
  const size = isRectLayout ? 'w-12 h-12' : 'w-10 h-10';
  return (
    <div className='flex items-center justify-center p-0.5'>

      <div
        className={`${colors.containerColor} flex items-center justify-center  rounded-full ${isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
        <HoverBox
          id='tooltip'
          variant='dark'
          className={`group flex items-center justify-center rounded-full ${size} ${colors.hoverBg}`}
          svg={isMuted ? <VolumeOffIcon size={24} className={`${colors.textColor} ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''} transition-none!`} /> : <VolumeUpIcon size={24} className={`${colors.textColor} ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''} transition-none!`} />}
          position='top'
          handleSvgClick={isDisabled ? undefined : handleVolumeToggle}
          tooltipHeader={null}
          toolTipDescription={isMuted ? 'Turn off sound' : 'Turn on sound'}
          children={null}
        />
      </div>
    </div>
  );
};

export default Volume;
